import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit ground piece: a 1x2 m slab exactly 0.06 thick (top at y = 0.06),
// centred on the origin, seating seamlessly against every other ground tile.
const ASPHALT = "#3f4044";
const MARKING = "#e8e6e0";

export const parkingSpot = defineModel({
  id: "parking-spot",
  batchId: "modern",
  name: "Parking spot",
  tags: ["modern", "outdoor", "ground", "street", "road", "asphalt", "parking"],
  summary: "A 1x2 asphalt parking bay with a white U marking.",
  description:
    "A 1x2-tile parking bay of the Modern Living kit: an asphalt slab " +
    "(0.06 m thick) with a white U-shaped bay marking — two side lines along " +
    "Z joined by an end line at -Z, open at +Z where the car enters. Tiles " +
    "seamlessly with every other ground piece.",
  tiles: { w: 1, h: 2 },
  footprint: 1.2,
  parts(): Part[] {
    return [
      { geometry: new THREE.BoxGeometry(1.0, 0.06, 2.0), color: ASPHALT, position: [0, 0.03, 0] },
      // Two side lines along Z, stopping short of the +Z (open) edge.
      {
        geometry: new THREE.BoxGeometry(0.06, 0.012, 1.84),
        color: MARKING,
        position: [-0.44, 0.06, -0.05],
      },
      {
        geometry: new THREE.BoxGeometry(0.06, 0.012, 1.84),
        color: MARKING,
        position: [0.44, 0.06, -0.05],
      },
      // The end line closing the bay at -Z.
      {
        geometry: new THREE.BoxGeometry(0.94, 0.012, 0.06),
        color: MARKING,
        position: [0, 0.06, -0.94],
      },
    ];
  },
  animations: [],
});
